<template>
  <v-container>
    <div>
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div v-else>
        <div
          id="idTable"
          style="max-width: 100%;"
        >
          <table
            style="width: 100%; overflow-x: auto; color: black; border-collapse: collapse;"
            class="elevation-1"
            mobile-breakpoint="0"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Produto
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Faturamento
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Quantidade
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Preço méd. produtos
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Variação pre. anual
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  ABC de grupos
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in mixComprado"
                :key="item.id"
              >
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.grupo_produto }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.faturamento }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.quantidade }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.preco_medido }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.variacao_anual }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.abc_grupo }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <router-link
          to="/clientes/extrato-clientes-faturado/detalhe-mix-comprado"
          :style="styleObject"
        >
          <div
            id="linkDetalheClienteDadosMaioresCrescimento"
            class="text-center"
          >
            <v-icon
              id="iconLinkClienteDadosMaioresCrescimento"
              class="text-center"
            >
              mdi-chevron-double-down
            </v-icon><br>
          </div>
        </router-link>
      </div>
    </div>
  </v-container>
</template>

<script>
  import Clientes from '../../../../../../services/clientes'
  import eventEmit from '../../../core/EventoEmit'

  export default {
    name: 'ShowExtratoClientesFaturados',
    emits: [],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      vendedorSelect: [],
      areaSelect: [],
      redeSelect: [],
      supervisorSelect: [],
      receita: [],
      categoria: [],
      promotor: [],
      selectCliente: JSON.parse(localStorage.clienteSelect),
      headersMixComprado: [
        { text: 'Produto', value: 'grupo_produto', width: '150px', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', width: '120px', align: 'right', class: 'black--text title' },
        { text: 'Quantidade', value: 'quantidade', width: '120px', align: 'right', class: 'black--text title' },
        { text: 'Preço méd. produtos', value: 'preco_medido', width: '120px', align: 'right', class: 'black--text title' },
        { text: 'Variação pre. anual', value: 'variacao_anual', width: '120px', align: 'right', class: 'black--text title' },
        { text: 'ABC de grupos', value: 'abc_grupo', width: '120px', align: 'right', class: 'black--text title' },
      ],
      mixComprado: [],
    }),

    created () {
      eventEmit.$on('set-comparativo-evolucao-cliente', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-comparativo-evolucao-cliente', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, ultimoDia, select, selectCliente, vendedor, area, rede, supervisor, receita, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = ultimoDia
        this.select = select
        this.selectCliente = selectCliente
        this.vendedorSelect = vendedor
        this.areaSelect = area
        this.redeSelect = rede
        this.supervisorSelect = supervisor
        this.receita = receita
        this.categoria = categoria
        this.promotor = promotor

        this.showDadosPerfilMixComprado()
      },

      async showDadosPerfilMixComprado () {
        this.loading = true

        this.mixComprado = []

        await Clientes.showPerfilMixComprado(this.primeiroDia, this.ultimoDia, this.select, this.selectCliente, localStorage.tokencontrato, this.vendedorSelect, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.mixComprado = resposta.data.mixComprado.map((item) => {
              var listaMix = ({
                grupo_produto: item.grupo_produto,
                faturamento: item.faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                quantidade: item.quantidade,
                preco_medido: item.preco_medido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                variacao_anual: item.variacao_anual + '%',
                abc_grupo: item.abc_grupo + '%',
              })

              return listaMix
            })
          } else if (resposta.data.msg === 'Não há dados semestral para a exibição') {
            this.mixComprado = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          } else if (resposta.data.msg === 'Data Final não pode ser mair que a data inicial') {
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false
        })
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px !important;
    }

    th, td {
      padding: 8px;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>
